import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FileText, Star } from "lucide-react";
import { fmtPriceHT, fmtPriceTTC } from "@/lib/prices";
import { cdn } from "@/lib/img";

export default function ProductCard({ item, baseUrl = "/mini-pelles" }) {
  return (
    <article data-testid={`product-card-${item.slug}`} className="lmb-card overflow-hidden flex flex-col">
      <Link to={`${baseUrl}/${item.slug}`} className="block">
        <div className="aspect-[16/10] sm:aspect-[4/3] overflow-hidden bg-white relative flex items-center justify-center">
          <img src={cdn(item.image_principale, 640)} alt={`Mini-pelle ${item.modele} neuve`} loading="lazy" decoding="async" className="w-full h-full object-contain p-3 transition-transform duration-500 hover:scale-105" />
          {item.stock && (
            <div className="absolute top-3 left-3 lmb-badge lmb-badge-stock backdrop-blur bg-white/90">{item.stock}</div>
          )}
          {item.best_seller && (
            <div className="absolute top-3 right-3 lmb-badge lmb-badge-premium flex items-center gap-1">
              <Star size={10} fill="currentColor" /> BEST-SELLER
            </div>
          )}
        </div>
      </Link>
      <div className="p-4 sm:p-6 flex-1 flex flex-col">
        <div className="text-[10px] font-mono-tech tracking-widest text-[#D8B86A] uppercase mb-1">Mini-pelle RIPPA</div>
        <h3 className="font-heading text-xl sm:text-2xl font-black text-[#072135] mb-1 leading-tight">{item.modele}</h3>
        {item.subtitle && <div className="text-sm text-[#4B5563] mb-2 sm:mb-3">{item.subtitle}</div>}

        <div className="grid grid-cols-2 gap-x-3 gap-y-1 sm:gap-y-1.5 text-xs mb-3 sm:mb-5 font-mono-tech">
          {item.poids_kg ? (
            <div className="flex items-baseline gap-1.5">
              <span className="text-[#4B5563]">Poids</span>
              <span className="font-bold text-[#072135]">{item.poids_kg} kg</span>
            </div>
          ) : null}
          {item.largeur_mm ? (
            <div className="flex items-baseline gap-1.5">
              <span className="text-[#4B5563]">Largeur</span>
              <span className="font-bold text-[#072135]">{item.largeur_mm} mm</span>
            </div>
          ) : null}
          {item.profondeur_fouille_mm ? (
            <div className="flex items-baseline gap-1.5 col-span-2">
              <span className="text-[#4B5563]">Fouille</span>
              <span className="font-bold text-[#072135]">{item.profondeur_fouille_mm} mm</span>
            </div>
          ) : null}
          {item.moteur_type_court ? (
            <div className="flex items-baseline gap-1.5 col-span-2">
              <span className="text-[#4B5563]">Moteur</span>
              <span className="font-bold text-[#072135] truncate">{item.variantes?.length > 1 ? item.variantes.map((v) => v.moteur).join(" ou ") : item.moteur_type_court}</span>
            </div>
          ) : null}
        </div>

        <div className="mt-auto">
          <div className="mb-3 pb-3 sm:mb-4 sm:pb-4 border-b border-gray-200 flex items-end justify-between gap-2 sm:block">
            <div>
              <div className="text-[10px] uppercase tracking-widest text-[#4B5563] font-mono-tech mb-1">À partir de</div>
              <span className="lmb-price text-xl sm:text-2xl">{fmtPriceTTC(item)}</span>
            </div>
            <div className="text-xs text-[#4B5563] font-mono-tech">{fmtPriceHT(item)}</div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Link data-testid={`view-${item.slug}`} to={`${baseUrl}/${item.slug}`} className="lmb-btn-secondary text-xs px-3 py-2.5 w-full whitespace-nowrap">
              Voir la fiche <ArrowRight size={14} className="hidden sm:inline" />
            </Link>
            <Link data-testid={`devis-${item.slug}`} to={`${baseUrl}/${item.slug}#devis`} className="lmb-btn-primary text-xs px-3 py-2.5 w-full">
              <FileText size={14} /> Devis
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}
